import React from "react";
import { Routes, Route, Navigate } from "react-router";
import LoginForm from "../views/LoginForm";
import Index from "../views/Index";
import AppointmentRecord from "../views/AppointmentRecords/AppointmentRecord";
import Accounts from "../views/Accounts/Accounts";
import Resources from "../views/Resources";
import Activation from "../views/Activation/Activation";
import ConfirmMFA from "../views/ConfirmMFA";
import ForgotPassword from "../views/ForgotPassword";
import AccountAccess from "../views/AccountAccess";
import EmailConfirmation from "../views/EmailConfirmation";
import EnableMFA from "../views/EnableMFA";
import ResetPassword from "../views/ResetPassword";
import PrivateRoute from "../components/AuthContext/PrivateRoute";
import PatientRecord from "../views/PatientRecords/PatientRecord";
import PatientDetails from "../views/PatientRecords/PatientDetails";
import UserDetails from "../views/PatientRecords/UserDetails";
import EnterBarcode from "../views/PatientRecords/EnterBarcode";
import ConfirmDetails from "../views/PatientRecords/ConfirmDetails";
import ChangePassword from "../views/ChangePassword";
import ConfirmationSteps from "../views/PatientRecords/ConfirmationSteps";
import AppointmentConfirmation from "../views/PatientRecords/AppointmentConfirmation";
import NotFound from "../components/NotFound";
import WelcomePage from "../views/WelcomePage";
import StoreLocation from "../views/StoreLocation";
import NoPatientFoundCard from "../stories/Cards/NoPatientFoundCard";
import ClinicalDetails from "../views/PatientRecords/ClinicalDetails";
import ClinicalConfirmationSteps from "../views/PatientRecords/ClinicalConfirmationSteps";
import SelectPatient from "../views/PatientRecords/SelectPatient";
import Search from "../views/Search";
import ClinicalMeasurements from "../views/VitalityHealthchecks/ClinicalMeasurements";
import ClinicalScreening from "../views/VitalityHealthchecks/ClinicalScreening";
import ConsultationCancelled from "../views/VitalityHealthchecks/ConsultationCancelled";
import ResultOutcome from "../views/VitalityHealthchecks/ResultOutcome";
import ResultSummary from "../views/VitalityHealthchecks/ResultSummary";
const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<Navigate to="/login" replace />} path="/" />
      <Route element={<LoginForm />} path="/login" />
      <Route
        element={<PrivateRoute element={PatientRecord} />}
        path="/patient-record"
      />
      <Route element={<PrivateRoute element={WelcomePage} />} path="/welcome" />
      <Route element={<PrivateRoute element={StoreLocation} />} path="/store" />
      <Route
        element={<PrivateRoute element={PatientDetails} />}
        path="/patient-record/patient-details"
      />
      <Route
        element={<PrivateRoute element={ClinicalDetails} />}
        path="/patient-record/clinical-details"
      />
      <Route
        element={<PrivateRoute element={SelectPatient} />}
        path="/patient-record/select-patient"
      />
      <Route
        element={<PrivateRoute element={NoPatientFoundCard} />}
        path="/patient-record/clinical-details-not-found"
      />
      <Route
        element={<PrivateRoute element={UserDetails} />}
        path="/patient-record/user-details"
      />
      <Route
        element={<PrivateRoute element={AppointmentRecord} />}
        path="/appointments-record"
      />
      <Route element={<PrivateRoute element={Accounts} />} path="/account" />
      <Route element={<PrivateRoute element={Resources} />} path="/resources" />
      <Route element={<Activation />} path="/my-account/:id" />
      {/* <Route element={<ConfirmMFA />} path="/enable-webauthn" /> */}
      <Route element={<ForgotPassword />} path="/forgot-password" />
      {/* Shared "sign in with SSO" screen - reached either by submitting
          the /forgot-password form for an SSO-managed email, or by a
          direct redirect from LoginForm when an SSO-managed user tries
          the normal email/password login (LoginForm.jsx's
          isSsoLoginBlocked). The URL only changes to this page once one
          of those two things actually happens, never just from visiting
          /forgot-password. */}
      <Route element={<AccountAccess />} path="/account-access" />
      <Route element={<EmailConfirmation />} path="/email-confirmation" />
      <Route
        element={<PrivateRoute element={EnableMFA} />}
        path="/enable-otp"
      />
      <Route element={<ResetPassword />} path="/reset-password/:uuid/:id" />
      <Route
        element={<PrivateRoute element={EnterBarcode} />}
        path="/enter-barcode/:id"
      />
      <Route
        element={<PrivateRoute element={ConfirmDetails} />}
        path="/test-confirmation/:id"
      />
      <Route
        element={<PrivateRoute element={AppointmentConfirmation} />}
        path="/appointment-confirmation/:id"
      />
      <Route
        element={<PrivateRoute element={ConfirmationSteps} />}
        path="/confirmation-steps/:id"
      />
      <Route
        element={<PrivateRoute element={ClinicalConfirmationSteps} />}
        path="/clinical-confirmation-steps/:id"
      />
      <Route
        element={<PrivateRoute element={ChangePassword} />}
        path="/change-password"
      />
      <Route element={<PrivateRoute element={Search} />} path="/search" />
      {/* region Vitality Healthchecks apis */}
      <Route
        element={<PrivateRoute element={ClinicalScreening} />}
        path="/clinical-screening"
      />
      <Route
        element={<PrivateRoute element={ClinicalMeasurements} />}
        path="/clinical-measurement"
      />
      <Route
        element={<PrivateRoute element={ResultSummary} />}
        path="/result-summary"
      />
      <Route
        element={<PrivateRoute element={ResultOutcome} />}
        path="/result-outcome"
      />
      <Route
        element={<PrivateRoute element={ConsultationCancelled} />}
        path="/consultation-cancelled"
      />
      <Route
        element={<PrivateRoute element={ConsultationCancelled} />}
        path="/consultation-success"
      />
      {/* endregion */}
      <Route element={<NotFound />} path="*" />
    </Routes>
  );
};
export default AppRoutes;
